import React from 'react';
import LocationTemplate from './LocationTemplate';

const StokesPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Stokes"
      stateName="North Carolina"
      countyName="Pitt"
      zipCodes={["27884"]}
      latitude={35.6534}
      longitude={-77.2426}
      population={441}
      historicalFact="Small incorporated town in Pitt County."
      nearbyTowns={[
        "Greenville, NC",
        "Washington, NC",
        "Grimesland, NC",
        "Falkland, NC",
        "Bethel, NC",
        "Robersonville, NC",
        "Williamston, NC",
        "New Bern, NC"
      ]}
    />
  );
};

export default StokesPage;